import React from "react";
import DiscoverPage from "../Dashboard/DiscoverPage";
import ExclusiveDeals from "../Dashboard/ExclusiveDeals";
import Activities from "../Dashboard/Activities";
import PopularVendors from "../Dashboard/PopularVendors";
import StateSection from "../Dashboard/StateSection";
import PopularCategories from "../Dashboard/PopularCategories ";
import CommunitySection from "../Dashboard/CommunitySection";
import HowItWorks from "../Dashboard/HowItWorks";
import {
  useGetAllActivitiesQuery,
  useGetAllPopularDealsQuery,
  useGetVendorsQuery,
} from "../../redux/service/vendorService";

const Home = () => {
  // RTK Query hooks
  const {
    data: DealsData,
    error: DealsError,
    isLoading: isLoadingDeals,
    refetch: DealsRefetch,
  } = useGetAllPopularDealsQuery();
  const {
    data: activitiesData,
    error: activitiesError,
    isLoading: isLoadingActivitiesData,
    refetch: activitiesDataRefetch,
  } = useGetAllActivitiesQuery();
  const {
    data: vendorsData,
    error: vendorsError,
    isLoading: isLoadingVendorsData,
  } = useGetVendorsQuery();
  return (
    <>
      <DiscoverPage
        productDealsData={DealsData}
        productDealsError={DealsError}
        activitiesData={activitiesData}
        activitiesError={activitiesError}
        vendorsData={vendorsData}
        vendorsError={vendorsError}
      />
      <StateSection />
      <ExclusiveDeals
        dealsData={DealsData}
        error={DealsError}
        isLoading={isLoadingDeals}
        refetch={DealsRefetch}
      />
      <PopularCategories />
      <Activities
        activitiesData={activitiesData}
        error={activitiesError}
        isLoading={isLoadingActivitiesData}
        refetch={activitiesDataRefetch}
      />
      <HowItWorks />
      <PopularVendors
        vendorsData={vendorsData}
        error={vendorsError}
        isLoading={isLoadingVendorsData}
      />
      <CommunitySection />
    </>
  );
};

export default Home;
